import { createTheme } from '@material-ui/core/styles';
import baseTheme from './baseTheme';
import COLORS from '../utils/constants/colors';

const cleaningTheme = createTheme({
  ...baseTheme,
  palette: {
    ...baseTheme.palette,
    primary: {
      main: COLORS.SR_GREEN, // shade of green
      light: COLORS.SR_GREEN_10,
    },
    secondary: {
      main: COLORS.GREY_01,
      light: COLORS.WHITE,
      contrastText: '#fafafa',
      dark: COLORS.DARK_GREY,
    },
    background: {
      paper: '#f4f4f4',
      default: COLORS.WHITE,
    },
    text: {
      primary: COLORS.BLACK,
      secondary: '#909090',
      disabled: COLORS.DISABLED_GREY,
    },
  },
});
export { cleaningTheme };
